var map = {
	"./footer.de-CH.json": 1006,
	"./footer.de-DE.json": 1007,
	"./footer.en-CA.json": 1008,
	"./footer.en-GB.json": 1009,
	"./footer.en-IN.json": 1010,
	"./footer.en-ME.json": 1011,
	"./footer.en-US.json": 1012,
	"./footer.es-EM.json": 1013,
	"./footer.es-ES.json": 1014,
	"./footer.fr-BE.json": 1015,
	"./footer.fr-CA.json": 1016,
	"./footer.fr-CH.json": 1017,
	"./footer.nl-BE.json": 1018,
	"./footer.nl-NL.json": 1019,
	"./footer.pl-PL.json": 1020,
	"./footer.pt-BR.json": 1021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1005;